import { Component, Input } from '@angular/core';

/**
 * Generic flex-row action/filter bar, replacing ad hoc Bootstrap .row/.col-sm-* filter-bar
 * markup that's otherwise copy-pasted per feature page.
 */
@Component({
    selector: 'app-toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss'],
})
export class ToolbarComponent {
    @Input() dense = false;
}
